import { AppLayout, BreadcrumbGroup, Container, Header, Button, SpaceBetween, FormField, Input, Box } from '@amzn/awsui-components-react';
import React, { useState, useEffect } from 'react';
import { AppContext, getInitialAppContext } from '../../utils/appContext';
import { Navbar } from '../../utils/Navbar';
import { Sidebar } from '../../utils/sidebar';
import { tumblerNavbarOptions } from '../../tumblerConstants';
import { apiCall, getDefaultStack } from '../../sdpds/utils';
import { ComponentReleaseTrackerDetail } from '../../sdpds/application/ComponentReleaseTracker/Details/ComponentReleaseTrackerDetail';
import ElementErrorBoundary from "../../sdpds/components/ErrorBoundary/ElementErrorBoundary";

const ComponentReleaseTracker = () => {
  const appContext = getInitialAppContext();
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [stackName, setStackName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const [state, setState] = useState({
    ...getInitialAppContext(),
    setTimezone: (timezone) => setState({ ...state, timezone }),
    setBreadcrumbs: (breadcrumbs) => setState({ ...state, breadcrumbs })
  });

  const fetchDefaultStack = async () => {
    setIsLoading(true);
    try {
      const config = await apiCall('/getConfig', {});
      if (config.statusCode === 200) {
        const defaultStack = getDefaultStack(config.body);
        setStackName(defaultStack);
      } else {
        throw new Error('Failed to fetch stack configuration');
      }
    } catch (error) {
        console.error('Error fetching default stack:', error);
        setStackName('');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDefaultStack();
  }, []);

  return (
      <ElementErrorBoundary>
        <div>
          <Navbar
              title={'Component Release Tracker'}
              homeUrl="/component-release-tracker"
              regionSwitcherActive={true}
              dropdownOptions={tumblerNavbarOptions}
          />
          <div style={{ paddingTop: '60px' }}>
            <AppLayout
                disableContentPaddings={false}
                content={
                  <AppContext.Provider value={state}>
                    {isLoading ? (
                        <Container>
                          <Box padding="m">Loading stack information...</Box>
                        </Container>
                    ) : stackName ? (
                        <SpaceBetween direction="vertical" size="l">
                          <Box>
                            <SpaceBetween direction="horizontal" size="xxs">
                              <strong>Stack:</strong>
                              <span>{stackName}</span>
                            </SpaceBetween>
                          </Box>
                          <ComponentReleaseTrackerDetail stackName={stackName} />
                        </SpaceBetween>
                    ) : null}
                  </AppContext.Provider>
                }
                toolsHide={true}
                navigation={<Sidebar />}
                navigationOpen={navigationOpen}
                onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
                headerSelector="#navbar"
                breadcrumbs={
                  <BreadcrumbGroup
                      items={appContext.breadcrumbs}
                      ariaLabel="Breadcrumbs"
                  />
                }
            />
          </div>
        </div>
      </ElementErrorBoundary>
  );
};

export { ComponentReleaseTracker };
